import {createFeatureSelector, createSelector} from "@ngrx/store";
import {UniverseAccountResourceFeatureKey} from "./universe-account-resource.reducer";
import {UniverseAccountResource} from "../../models/UniverseAccountResource";

export const universeAccountResourceSelector = createFeatureSelector<UniverseAccountResource[]>(UniverseAccountResourceFeatureKey);
